import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import loanBrokerBlueIcon from '../../../../assets/icons/loanBrokerIcon.svg';
import loanBrokerGrayIcon from '../../../../assets/icons/loanBrokerGrayIcon.svg';
import ecomBlueIcom from '../../../../assets/icons/ecomBlueIcon.svg';
import ecomGrayIcom from '../../../../assets/icons/ecomGrayIcon.svg';
import sassBlueIcon from '../../../../assets/icons/sassBlueIcon.svg';
import sassGrayIcon from '../../../../assets/icons/sassIcon.svg';
import otherBlueIcon from '../../../../assets/icons/otherBlueIcon.svg';
import otherGrayIcon from '../../../../assets/icons/otherIcon.svg';
import ConversionSetupBox from '../../../../components/conversionSetupBox/conversionSetupBox';
import { useUpdateOrganizationSettings } from '../../../../apiHooks/mutations/organizationMutations/organizationSettingsMutations';
import { useOrganizationSettingsStore } from '../../../../store/organizationSettingsStore';

const OrganizationTypePanel = () => {
  const { t } = useTranslation();
  const { organizationSettings, setOrganizationSettings } = useOrganizationSettingsStore();
  const [selectedOption, setSelectedOption] = useState<string>(organizationSettings.organizationType || '');
  const { mutateAsync: updateOrganizationSettings } = useUpdateOrganizationSettings();

  const handleOptionSelected = async (title: string) => {
    setSelectedOption(title);

    // Map UI title to backend OrgType value
    const orgTypeMap: Record<string, string> = {
      loanBroker: 'loanBroker',
      eCommerce: 'eCommerce',
      saas: 'saas',
      other: 'other',
    };

    const OrgType = orgTypeMap[title] || title;

    await updateOrganizationSettings({ OrgType, organizationType: OrgType });
    setOrganizationSettings({ ...organizationSettings, organizationType: OrgType });
  };

  return (
    <div className="h-full rounded-lg bg-white p-8">
      <div className="flex h-full max-h-[280px] flex-col">
        <p className="text-2xl font-normal text-primary">
          {t('chooseOrganization')}
        </p>
        <div className="flex h-full w-full items-center justify-between">
          <ConversionSetupBox
            title="loanBroker"
            imgSource={selectedOption === 'loanBroker' ? loanBrokerBlueIcon : loanBrokerGrayIcon}
            onSelected={() => handleOptionSelected('loanBroker')}
            selected={selectedOption === 'loanBroker'}
          />
          <ConversionSetupBox
            title="eCommerce"
            imgSource={selectedOption === 'eCommerce' ? ecomBlueIcom : ecomGrayIcom}
            onSelected={() => handleOptionSelected('eCommerce')}
            selected={selectedOption === 'eCommerce'}
          />
          <ConversionSetupBox
            title="saas"
            imgSource={selectedOption === 'saas' ? sassBlueIcon : sassGrayIcon}
            onSelected={() => handleOptionSelected('saas')}
            selected={selectedOption === 'saas'}
          />
          <ConversionSetupBox
            title="other"
            imgSource={selectedOption === 'other' ? otherBlueIcon : otherGrayIcon}
            onSelected={() => handleOptionSelected('other')}
            selected={selectedOption === 'other'}
            isLast
          />
        </div>
      </div>
    </div>
  );
};

export default OrganizationTypePanel;
